import React, { memo } from "react"
import Svg, { Path } from "react-native-svg"
import { Colors } from "src/constants/Colors"

type Props = {
  fill?: string
}

export const OpenInNewIcon = memo<Props>(({ fill = Colors.orange }) => (
  <Svg width={16} height={16} viewBox="0 0 16 16" fill="none">
    <Path
      d="M13.4444 13.4444H2.55556V2.55556H8V1H2.55556C1.69222 1 1 1.7 1 2.55556V13.4444C1 14.3 1.69222 15 2.55556 15H13.4444C14.3 15 15 14.3 15 13.4444V8H13.4444V13.4444ZM9.55556 1V2.55556H12.3478L4.70222 10.2011L5.79889 11.2978L13.4444 3.65222V6.44444H15V1H9.55556Z"
      fill={fill}
    />
  </Svg>
))
